// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-filter .bolt-button {
  border-radius: 120px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  background: transparent;
  border:  1px solid;
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
.bolt-filter .bolt-button:hover {
  background: rgba( 239, 239, 239 ,  1 );
  background: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}
.bolt-filter .bolt-button:active {
  background: rgba( 218, 218, 218 ,  1 );
  background: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}

.bolt-filter-callout .bolt-actions-container {
  flex-direction: row;
  justify-content: flex-end;
}

.bolt-filter-callout .bolt-dropdown-header-container {
  border: none;
}

.bolt-filter-callout.bolt-active-filter .bolt-dropdown-header {
  padding-left: 12px;
}

.bolt-filter-reset-button.bolt-button {
  margin-right: 8px;
}

.bolt-filter-apply-button.bolt-button {
  margin-left: auto;
}

.bolt-filter.bolt-filter-on .bolt-button {
  color: rgba( 0, 90, 158 ,  1 );
  color: rgba( var(--palette-primary-shade-20,0, 90, 158) ,  1 );
}

.bolt-filter-label {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-filter-label.bolt-filter-label-selected {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
@media (forced-colors: active) {
  .bolt-filter-label {
    background-color: window;
  }
}

.bolt-filter-item {
  height: 48px;
  padding-left: 16px;
  padding-right: 12px;
  border-top: 1px solid;
  border-color: rgba(0, 0, 0, 0.06);
  border-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
  border-left: 2px solid transparent;
}

.bolt-filter-listbox-container {
  padding: 0px;
}

.bolt-filter-item:hover {
  background: rgba( 248, 248, 248 ,  1 );
  background: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
}
@media (forced-colors: active) {
  .bolt-filter-item:hover {
    background-color: highlight;
  }
}
.bolt-filter-item:hover {
  border-left:  2px solid;
  border-left-color: rgba( 43, 136, 216 ,  1 );
  border-left-color: rgba( var(--palette-primary-tint-10,43, 136, 216) ,  1 );
}

.bolt-filter-item:focus {
  outline: none;
  background: rgba( 248, 248, 248 ,  1 );
  background: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
}
@media (forced-colors: active) {
  .bolt-filter-item:focus {
    background-color: highlight;
  }
}
.bolt-filter-item:focus {
  border-left:  2px solid;
  border-left-color: rgba( 43, 136, 216 ,  1 );
  border-left-color: rgba( var(--palette-primary-tint-10,43, 136, 216) ,  1 );
}

.bolt-filter-back-button.bolt-button {
  margin-right: 12px;
  font-weight: normal;
}

.bolt-filter-selection-pill {
  margin-left: 4px;
  font-weight: normal;
}

.bolt-filter-selected-item-container {
  overflow: hidden;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  margin-left: 16px;
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba( 0, 0, 0 ,  1 ) 30px);
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba( var(--palette-neutral-100,0, 0, 0) ,  1 ) 30px);
  -webkit-mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0), rgba( 0, 0, 0 ,  1 ) 30px);
  -webkit-mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0), rgba( var(--palette-neutral-100,0, 0, 0) ,  1 ) 30px);
}

.bolt-filter-selected-item {
  margin-right: 16px;
}

.bolt-filter-selected-text-item {
  margin-right: 4px;
}

.bolt-filter-keyword-item {
  margin: 0 16px 16px 16px;
}

.bolt-filter-title-container {
  height: 20px;
}

.bolt-filter-callout .bolt-filtered-header {
  padding-top: 8px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  font-weight: 600;
}
.bolt-filter-callout .bolt-filtered-header .body-m {
  font-size: 0.75rem;
}

/*# sourceMappingURL=Filter.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Filter/Filter.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Filter/Filter.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,oBAAA;EACA,yBC8Ja;ED7Jb,qDAAA;EACA,uBAAA;EEAF,kBAAkB;EFEhB,wCAAA;EACI,kEC4EI;AC5EZ;AFGI;EACI,sCCgEK;ECjEX,+DAA+D;AACjE;AFIA;EACI,sCAAA;EACA,gEAAA;AEFJ;;AFKA;EACI,mBAAA;EEFF,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EFI5B,8DAAA;AEFJ;;ACKI;EHNJ,wBAAA;EEKE,kDFGM;AEFR;AACA;EACE,wBAAwB;EFI1B,kDAAA;AEFA;AACA;EFII;IACA,wBAAA;EACA;AEFJ;;AAEA;EFIA,YAAA;EACI,kBAAA;EEFF,mBAAmB;EACnB,qBAAqB;EFIvB,iCAAA;EACI,8DCyBQ;EC3BV,kCAAkC;AClBhC;;ADqBJ;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,+DAA+D;AFCjE;AECA;EFCI;IECA,2BAA2B;EC/B3B;ADiCJ;AACA;EACE,uBAAuB;EACvB,4CAA4C;EFR9C,2EAAA;AEUA;;AAEA;EFFA,aAAA;EACI,sCCuOS;EDtOT,+DC0Me;ACtMnB;AACA;EFFA;IACI,2BAAA;EACA;AEIJ;AACA;EFFA,uBAAA;EACI,4CAAA;EACA,2EC4DW;ACxDf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AFFrB;;AEKA;EACE,gBAAgB;EFFlB,mBAAA;AEIA;;AAEA;EFFA,gBAAA;EACI,wBAAA;EEIF,kDAAkD;EAClD,iBAAiB;EFFnB,iFAAA;EACI,4GCiNS;EC7MX,+FAA+F;EAC/F,0HAA0H;AFF5H;;AEKA;EFFI,kBC+KiB;AC3KrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
